import classNames from 'classnames';
import styles from './notification-dot.scss';
import React from 'react';

export const NotificationDot: React.FC<{
  inline?: boolean;
  lgOnly?: boolean;
  hideLg?: boolean;
}> = ({ inline, lgOnly, hideLg }) => {
  return (
    <div
      className={classNames(styles.dot, {
        [styles.inline]: inline,
        [styles.lgOnly]: lgOnly,
        [styles.hideLg]: hideLg,
      })}
    />
  );
};
